/**
 * @generated SignedSource<<0083353d671caf86cf7b17898750ad7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditableRoundsList_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EditableRound_Booking">;
  readonly " $fragmentType": "EditableRoundsList_Booking";
};
export type EditableRoundsList_Booking$key = {
  readonly " $data"?: EditableRoundsList_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditableRoundsList_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditableRoundsList_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditableRound_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "4b34b84098b57beea7688e69cf59bbb6";

export default node;
